var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotCertified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.81 18.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.69,2.87h2.23c.92,0,1.67.75,1.67,1.67v2.23l1.59,1.59c.65.65.65,1.71,0,2.36l-1.59,1.59v2.26c0,.92-.75,1.67-1.67,1.67h-2.26l-1.57,1.57c-.65.65-1.71.65-2.36,0l-1.57-1.57h-2.26c-.92,0-1.67-.75-1.67-1.67v-2.26l-1.59-1.59C-.01,10.06-.01,9,.64,8.35l1.59-1.59v-2.23c0-.92.75-1.67,1.67-1.67h2.23l1.6-1.6c.65-.65,1.71-.65,2.36,0l1.6,1.6ZM6.13,4.54h-2.23v2.23c0,.44-.18.87-.49,1.18l-1.59,1.59,1.58,1.59c.31.31.49.74.49,1.18v2.26h2.26c.44,0,.87.18,1.18.49l1.57,1.57,1.57-1.57c.31-.31.74-.49,1.18-.49h2.26v-2.26c0-.44.18-.87.49-1.18l1.59-1.59-1.59-1.59c-.31-.31-.49-.74-.49-1.18v-2.23h-2.23c-.44,0-.87-.18-1.18-.49l-1.6-1.6-1.6,1.6c-.31.31-.74.49-1.18.49h0ZM8.91,14c-.62,0-1.11-.5-1.11-1.11s.5-1.11,1.11-1.11,1.11.5,1.11,1.11-.5,1.11-1.11,1.11ZM9.74,5.93v3.9c0,.46-.37.83-.83.83s-.84-.37-.84-.83v-3.9c0-.46.37-.83.84-.83s.83.37.83.83Z",
    fill: "#a8a8a8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotCertified);
export default __webpack_public_path__ + "static/media/not_certified.93682e14f61d5b5a63273e192bb2b5a9.svg";
export { ForwardRef as ReactComponent };